import { LocalStorageFeatureFlags } from '@backstage/core-app-api';
import type { FeatureFlagsSaveOptions } from '@backstage/core-plugin-api';
import { NEW_FRONTEND_SYSTEM_FLAG } from '@internal/frontend-common';

export class AppFeatureFlags extends LocalStorageFeatureFlags {
  constructor(private readonly reloadApp = () => window.location.reload()) {
    super();
  }

  save(options: FeatureFlagsSaveOptions): void {
    const wasNewFrontendSystemEnabled = this.isActive(NEW_FRONTEND_SYSTEM_FLAG);

    super.save(options);

    if (this.isActive(NEW_FRONTEND_SYSTEM_FLAG) !== wasNewFrontendSystemEnabled) {
      this.reloadApp();
    }
  }
}

export const featureFlagsApi = new AppFeatureFlags();
